<template>
	
	<div>
		<div v-if="device=='pc'">
		<box :customer="true" :autoLoad="true" :ref="boxRef" title="收款账号" :width="1000" :index="0" @hide="hide"
			@submit="submit" moduleName="bankaccount" :store="store" selectType="radio" @boxdataload="boxdataload" />
		</div>
		<div v-else>
			<phonebox :customer="true" :autoLoad="true" :ref="boxRef" title="收款账号" :width="1000" :index="0" @hide="hide"
				@submit="submit" moduleName="bankaccount" :store="store" selectType="radio" @boxdataload="boxdataload" />
		</div>
	</div>
	


</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				default: () => {
					return 'order'
				}
			},
			costobj: {
				default: () => {
					return null
				}
			},
			businessstaffid: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					buttons:[],
					columns: [{
						type: "",
						field: 'name',
						title: '名称',
						render: '$input'
					},{
						type: "",
						field: 'rcvAcc',
						title: '收款账号',
						render: '',
					}, {
						type: "",
						field: 'rcvBankName',
						title: '开户行',
						render: '$input'
					}, {
						field: 'rcvName',
						title: '收款人(公司)',
						render: '$input'
					}, {
						name:'relatedcompanytype',
						type: "",
						field: 'relatedcompanytype',
						title: '单位类型',
						render: '$emun',
						formatter:'relatedcompanytype'
						
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: true,
						pageSizes: [20, 50, 200],
						force: true
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			//this.box.getForm = this.getForm

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, updateForm) {
				return new Promise((resolve, reject) => {
					this.$api.bankaccount.list({
						costobj: this.costobj,
						businessstaffid: this.businessstaffid,
						...updateForm
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box,
			phonebox
		}
	}
</script>
